import DashboardIcon from "../assets/svg/dashboard.svg";
import ProjectIcon from "../assets/svg/note.svg";
import ProductIcon from "../assets/svg/cube.svg";
import DesignconsultIcon from "../assets/svg/penunderscore.svg";
import OrderIcon from "../assets/svg/data.svg";
import CustomerIcon from "../assets/svg/customer.svg";
import UserIcon from "../assets/svg/user.svg";
import AbandonedCartIcon from "../assets/svg/abandonedCart.svg";
import QuotesIcon from "../assets/svg/quotes.svg";

/* eslint-disable */
// 1. Dashboard
// 2. Orders
//     - Orders
//     - Create new Order
//     - Drafts
// 3. Customers
//     - Users & Professionals
//     - Create Customer
// 4. User Management
//     - User List
//     - Create User
// 5. Product Management
//     - Product List
//     - Create Product
//     - Variant List
//     - Create Variant
//     - Category List
//     - Create new Category
//     - Series List
//     - Create new Series
// 6. Project Management
//     - Project List
//     - Create new Project
//     - Drafts
// 7. Design Consultant
//     - Consultancy List
//     - Create Consultant
/* eslint-disable */

export interface NavItem {
  icon: string;
  heading?: string;
  title: string | undefined;
  to: string;
  cc?: string;
  ce?: string;
  cf?: string;
  cg?: string;
  ch?: string;
  ci?: string;
  cj?: string;
  ck?: string;
  cl?: string;
  subItems?: {
    title: string | undefined;
    to: string;
    permission?: string;
  }[];
}

export const navItems: NavItem[] = [
  {
    icon: DashboardIcon,
    title: "Dashboard",
    to: "/order-analytics",
    subItems: [
      // {
      //   title: "Dashboard",
      //   to: "/dashboard",
      // },
      {
        title: "Order Analytics",
        to: "/order-analytics",
      },
      {
        title: "General Analytics",
        to: "/general-analytics",
      },
    ],
  },
  {
    icon: OrderIcon,
    title: "Order Management",
    to: "/orders",
    cc: "/orders/create",
    subItems: [
      {
        title: "All Orders",
        to: "/orders",
        permission: "view_order",
      },
      {
        title: "Place new Order",
        to: "/orders/create",
        permission: "create_order",
      },
    ],
  },
  {
    icon: QuotesIcon,
    title: "Quotations",
    to: "/quotations",
    cc: "/quotations/create",
    subItems: [
      {
        title: "Quotations",
        to: "/quotations",
        permission: "view_quotation",
      },
    ],
  },
  {
    icon: DesignconsultIcon,
    title: "Lighting Consultant",
    to: "/consultancy-list",
    cc: "/create-consultant",
    subItems: [
      {
        title: "Consultancy Orders",
        to: "/consultancy-list",
        permission: "view_lc_order",
      },
      {
        title: "Place Order",
        to: "/create-consultant",
        permission: "create_lc_order",
      },
    ],
  },
  {
    icon: CustomerIcon,
    title: "Customer Management",
    to: "/customers",
    cc: "/customers/professionals/employee",
    ce: "/customers/professionals/company",
    cf: "/customers/professionals/pending-requests",
    subItems: [
      {
        title: "Customers",
        to: "/customers",
        permission: "view_customer",
      },
      {
        title: "Employee",
        to: "/customers/professionals/employee",
        permission: "view_customer",
      },
      {
        title: "Company",
        to: "/customers/professionals/company",
        permission: "view_customer",
      },
      {
        title: "Pending",
        to: "/customers/professionals/pending-requests",
        permission: "view_customer",
      },
    ],
  },

  {
    icon: UserIcon,
    title: "User Management",
    to: "/users",
    cc: "/users/create",
    subItems: [
      {
        title: "User List ",
        to: "/users",
        permission: "view_user",
      },
      {
        title: "Create User",
        to: "/users/create",
        permission: "create_user",
      },
      {
        title: "User Roles",
        to: "/users/roles",
        permission: "view_role",
      },
      {
        title: "Channel Partners",
        to: "/channel-partners",
        permission: "view_channel_partner",
      },
    ],
  },
  {
    icon: ProductIcon,
    title: "Product Management",
    to: "/products",
    cc: "/products/create",
    ce: "/products/variant-templates",
    cf: "/products/variant-templates/create",
    cg: "/products/categories",
    ch: "/products/categories/create",
    ci: "/products/series",
    cj: "/products/series/create",
    ck: "/products/brands",
    cl: "/products/brands/create",
    subItems: [
      {
        title: "Product List",
        to: "/products",
        permission: "view_product",
      },
      {
        title: "Variant Template List",
        to: "/products/variant-templates",
        permission: "view_product",
      },
      {
        title: "Category List",
        to: "/products/categories",
        permission: "view_product",
      },
      {
        title: " Series List",
        to: "/products/series",
        permission: "view_product",
      },
      {
        title: "Brands List",
        to: "/products/brands",
        permission: "view_product",
      },
      {
        title: "Track Configuration",
        to: "/products/track-configurator",
        permission: "view_product",
      },
    ],
  },
  {
    icon: ProjectIcon,
    title: "Project Management",
    to: "/projects",
    cc: "/projects/create",
    subItems: [
      {
        title: "Project List",
        to: "/projects",
        permission: "view_project",
      },
      {
        title: "Create new Project",
        to: "/projects/create",
        permission: "create_project",
      },
      // {
      //   title: "Pending Go-Live Approval",
      //   to: "/projects/approval-list",
      //   permission: "view_project",
      // },
    ],
  },
  {
    icon: AbandonedCartIcon,
    title: "Abandoned Cart",
    to: "/abandoned-cart",
    subItems: [
      {
        title: "Abandoned Carts",
        to: "/abandoned-cart",
        permission: "view_abandoned_cart",
      },
    ],
  },
  {
    icon: ProjectIcon,
    title: "Brief Management",
    to: "/briefs",
    subItems: [
      {
        title: "Brief List",
        to: "/briefs",
      },
    ],
  },
];
